import { render, staticRenderFns } from "./AuditHitsPerProject.vue?vue&type=template&id=72959db8&"
import script from "./AuditHitsPerProject.vue?vue&type=script&lang=js&"
export * from "./AuditHitsPerProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports